import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ["tab"]

  connect() {
    // Use setTimeout to ensure the DOM is fully loaded and avoid interference
    setTimeout(() => {
      this.scrollToActiveTab()
    }, 100)
  }

  scrollToActive() {
    this.scrollToActiveTab()
  }

  scrollToActiveTab() {
    // Only scroll if we're not in the middle of a drag operation
    if (this.isDragging()) {
      return
    }

    // Find the active tab (the one with active styling)
    const activeTab = this.tabTargets.find(tab => {
      // Check for active classes
      return tab.classList.contains('bg-blue-00') ||
             tab.classList.contains('border-blue-500') ||
             tab.classList.contains('active-current') ||
             tab.classList.contains('bg-blue-503-15') ||
             tab.getAttribute('aria-current') === 'page'
    })

    if (activeTab) {
      // Scroll the active tab into view with instant behavior on first load
      // Use 'center' to center the tab in the scrollable container
      activeTab.scrollIntoView({
        behavior: 'auto', // Changed from 'smooth' to 'auto' to avoid conflicts
        block: 'nearest',
        inline: 'center'
      })
    }
  }

  isDragging() {
    // Check if any element is currently being dragged
    return document.querySelector('.dragging') !== null ||
           document.querySelector('[draggable="true"]:active') !== null
  }
}
